import React from "react";

const NotFound = () => {
  return <h2 className="not-found">Page Not Found</h2>;
};

export default NotFound;
